var map = {
	"./de.json": [
		"6ce2",
		"locale-de-json"
	],
	"./en-US.json": [
		"e0e1",
		"locale-en-US-json"
	],
	"./en.json": [
		"edd4",
		"locale-en-json"
	],
	"./es.json": [
		"a306",
		"locale-es-json"
	],
	"./fr.json": [
		"f693",
		"locale-fr-json"
	],
	"./pt.json": [
		"5d67",
		"locale-pt-json"
	],
	"./zh-CN.json": [
		"423e",
		"locale-zh-CN-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;